class PlayerTrainingEntries {
  constructor(
    TrainingEntriesFactory,
    TrainingCentersFactory,
    PlayersFactory,
    $filter,
    ngDialog,
    $stateParams,
    $rootScope
  ) {
    "ngInject";
    const vm = this;

    let $translate = $filter("translate");

    const ACTIONS = {
      START: 1,
      END: 2,
      PAUSE: 3,
      UNPAUSE: 4,
      DELETE: 5,
    };

    vm.rootScope = $rootScope;

    vm.$onInit = () => {
      vm.playerId = $stateParams.id;
      vm.player = {};
      vm.trainingCenters = [];
      vm.reloadEntries();
      TrainingCentersFactory.getAll().then((response) => {
        vm.trainingCenters = response.data;
      });
    };

    vm.gridOptions = {
      paginationPageSizes: [50, 100, 150],
      paginationPageSize: 50,
      enableSorting: true,
      enableColumnMenus: false,
      enableFiltering: true,
      columnDefs: [
        {
          field: "id",
          enableFiltering: false,
          name: "ID",
          width: "70",
        },
        {
          field: "status",
          enableFiltering: false,
          name: $translate("STATUS"),
          width: "100",
          cellTemplate:
            "" +
            "<div " +
            'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
            '<div class="buttons">' +
            '<button class="btn btn-sm btn-success m-l-0" disabled translate ' +
            'ng-if="row.entity.started_at === null" ' +
            ">AVAILABLE</button>" +
            '<button class="btn btn-sm btn-info m-l-0" disabled translate ' +
            'ng-if="row.entity.started_at !== null && row.entity.ended_at === null && row.entity.paused === 0" ' +
            ">ACTIVE</button>" +
            '<button class="btn btn-sm btn-danger m-l-0" disabled translate ' +
            'ng-if="row.entity.ended_at !== null" ' +
            ">ENDED</button>" +
            '<button class="btn btn-sm btn-warning m-l-0" disabled translate ' +
            'ng-if="row.entity.paused === 1" ' +
            ">PAUSED</button>" +
            "</div>" +
            "</div>",
        },
        {
          field: "trainingCenterTitle",
          enableFiltering: false,
          name: $translate("TRAINING_CENTER"),
          width: "200",
        },
        {
          field: "started_at",
          enableFiltering: false,
          name: $translate("STARTED_DATE"),
          width: "180",
        },
        {
          field: "ended_at",
          enableFiltering: false,
          name: $translate("ENDED_DATE"),
          width: "180",
        },
        {
          field: "created_at",
          enableFiltering: false,
          name: $translate("CREATED_AT"),
          width: "180",
        },
        {
          field: "actions",
          enableFiltering: false,
          name: $translate("ACTIONS"),
          headerCellClass: "text-center",
          cellTemplate:
            "" +
            "<div " +
            'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
            '<div class="buttons">' +
            '<button class="btn btn-sm accent m-l-1" translate ' +
            'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_TRAINING_ENTRY) ' +
            '&& row.entity.started_at === null" ' +
            'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,1)">START</button>' +
            '<button class="btn btn-sm btn-warning m-l-1" translate ' +
            'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_TRAINING_ENTRY) ' +
            '&& row.entity.paused === 0 && row.entity.ended_at === null && row.entity.started_at !== null" ' +
            'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,3)">PAUSE</button>' +
            '<button class="btn btn-sm btn-success m-l-1" translate ' +
            'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_TRAINING_ENTRY) ' +
            '&& row.entity.paused === 1" ' +
            'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,4)">UNPAUSE</button>' +
            '<button class="btn btn-sm btn-primary m-l-1" translate ' +
            'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_TRAINING_ENTRY) ' +
            '&& row.entity.ended_at === null && row.entity.started_at !== null" ' +
            'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,2)">END</button>' +
            '<button class="btn btn-sm btn-danger m-l-1" translate ' +
            'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.DELETE_TRAINING_ENTRY) ' +
            '&& row.entity.ended_at === null" ' +
            'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,5)">DELETE</button>' +
            "</div>" +
            "</div>",
        },
      ],
    };

    vm.hasPermission = (permission) => {
      return vm.rootScope.user.canDo(permission);
    };

    vm.openAddTrainingEntriesModal = () => {
      vm.newEntries = {};
    };

    vm.addNewEntries = () => {
      TrainingEntriesFactory.create({
        amount: vm.newEntries.amount,
        training_center_id: vm.newEntries.trainingCenter.id,
        player_id: vm.playerId,
      }).then((response) => {
        ngDialog.open({ template: "successTemplate" });
        vm.reloadEntries();
      });
    };

    vm.actionTrainingEntry = (trainingEntryId, action) => {
      let question;
      switch (action) {
        case ACTIONS.START:
          question = "START_TRAINING_ENTRY";
          break;
        case ACTIONS.END:
          question = "END_TRAINING_ENTRY";
          break;
        case ACTIONS.PAUSE:
          question = "PAUSE_TRAINING_ENTRY";
          break;
        case ACTIONS.UNPAUSE:
          question = "UNPAUSE_TRAINING_ENTRY";
          break;
        case ACTIONS.DELETE:
          question = "DELETE_TRAINING_ENTRY";
          break;
      }
      ngDialog
        .openConfirm({
          template: "confirmTemplate",
          data: {
            message: $translate(question),
          },
        })
        .then(() => {
          let promise;
          switch (action) {
            case ACTIONS.START:
              promise = TrainingEntriesFactory.start(trainingEntryId);
              break;
            case ACTIONS.END:
              promise = TrainingEntriesFactory.end(trainingEntryId);
              break;
            case ACTIONS.PAUSE:
              promise = TrainingEntriesFactory.pause(trainingEntryId);
              break;
            case ACTIONS.UNPAUSE:
              promise = TrainingEntriesFactory.unpause(trainingEntryId);
              break;
            case ACTIONS.DELETE:
              promise = TrainingEntriesFactory.delete(trainingEntryId);
              break;
          }
          promise.then((response) => {
            ngDialog.open({ template: "successTemplate" });
            vm.reloadEntries();
          });
        });
    };

    vm.forceStartTrainingEntry = () => {
      PlayersFactory.startTrainingEntry(vm.playerId).then((response) => {
        ngDialog.open({ template: "successTemplate" });
        vm.reloadEntries();
      });
    };

    vm.getPlayerTrainingCard = () => {
      const tabWindowId = window.open("about:blank", "_blank");
      PlayersFactory.trainCard(vm.playerId).then((response) => {
        let file = new Blob([response.data], { type: "application/pdf" });
        tabWindowId.location.href = window.URL.createObjectURL(file);
      });
    };

    vm.reloadEntries = () => {
      PlayersFactory.getOne(vm.playerId, {
        include: "trainingEntries",
      }).then((response) => {
        vm.player = response.data;
        vm.gridOptions.data = response.data.trainingEntries;
      });
    };
  }
}

export default PlayerTrainingEntries;



// WEBPACK FOOTER //
// ./client/app/components/players/playerProfile/playerTrainingEntries/playerTrainingEntries.controller.js